export default __webpack_public_path__ + "static/media/Battery.eae03349.svg";